import { CouponDTO, CouponValidationDTO } from 'types/models/coupons';
import { bestpark } from './base-api';
import { CouponValidationResult } from 'constants/coupons';

const validateCoupon = async (
  data: CouponValidationDTO,
): Promise<CouponValidationResult> => {
  const result = await bestpark.post('/coupons/validate', data);
  return result.data;
};

const getCouponByCode = async (
  key: string,
  code: string,
): Promise<CouponDTO> => {
  const result = await bestpark.get(`/coupons/code/${code}`);
  return result.data;
};

export const couponsApi = {
  validateCoupon,
  getCouponByCode,
};
